export const CHAPTR_ORGANISATION_ID = "00000000-0000-0000-0000-00000000c4a5";
